/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';

/*------------------------------------*\
    PAYMENT MODAL
\*------------------------------------*/
class Modal {
    constructor(passedElement) {
        let self = this;
        self.elem = passedElement;
    }

    /*-------------------------------------------------*\
        INIT
    \*-------------------------------------------------*/
    init() {
        let self = this;

        $('#lecture-book-modal').on('show.bs.modal');
    };
}

export default Modal;